import { useEffect, useState } from 'react'
import {
   Dialog,
   DialogActions,
   DialogSurface,
   DialogTitle,
   DialogBody,
   DialogContent,
   Button,
   Input,
   Field,
   Textarea
} from '@fluentui/react-components'

export default function ConfirmationDialog({ open, onClose, onBuyerName, onBuyerContact, onNote, onConfirm, confirmLoading }) {

   const [buyerName, setBuyerName] = useState('')
   const [buyerContact, setBuyerContact] = useState('')
   const [note, setNote] = useState('')

   const [confirmDisabled, setConfirmDisabled] = useState(false)

   useEffect(() => {
      setConfirmDisabled(
         buyerName.trim().length < 1 ||
         buyerContact.trim().length < 1
      )
   }, [buyerName, buyerContact])

   useEffect(() => {
      onBuyerName(buyerName)
   }, [buyerName])

   useEffect(() => {
      onBuyerContact(buyerContact)
   }, [buyerContact])

   useEffect(() => {
      onNote(note)
   }, [note])


   const handleChangeBuyerName = e => setBuyerName(e.target.value)
   const handleChangeBuyerContact = e => setBuyerContact(e.target.value)
   const handleChangeNote = e => setNote(e.target.value)

   return (
      <Dialog open={open} onOpenChange={onClose}>
         <DialogSurface>
            <DialogBody>
               <DialogTitle>Konfirmasi Pembelian</DialogTitle>
               <DialogContent>
                  <div className="confirmation_form">
                     <div className="head">
                        <Input 
                           placeholder='Nama Pembeli' 
                           appearance='filled-lighter-shadow'
                           value={buyerName}
                           onChange={handleChangeBuyerName} />
                        <Input 
                           placeholder='Kontak Pembeli' 
                           appearance='filled-lighter-shadow'
                           value={buyerContact}
                           onChange={handleChangeBuyerContact} />
                     </div>
                  </div>
                  <Field label="Catatan" style={{marginTop: 10}}>
                     <Textarea placeholder='Catatan' 
                        appearance='filled-lighter-shadow'
                        resize='vertical'
                        style={{
                           height: 150
                        }}
                        value={note}
                        onChange={handleChangeNote}
                     />
                  </Field>
               </DialogContent>
               <DialogActions>
                  <Button
                     onClick={onClose}
                     appearance='outline'
                  >Batal</Button>
                  <Button
                     appearance='primary'
                     onClick={onConfirm}
                     disabled={confirmDisabled || confirmLoading}
                  >Proses pesanan</Button>
               </DialogActions>
            </DialogBody>
         </DialogSurface>
      </Dialog>
   )
}